import React, { PureComponent, Fragment, isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isValid } from 'ipaddr.js';
import { connect } from './MenuContext';
import Tooltip from '../tooltip';
import Check from '../icons/internals/Check';

/**
 *
 * MenuItem
 */
class MenuItem extends PureComponent {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /** MenuItem的值 */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    /** 被选中时回调  */
    onSelect: PropTypes.func,
    /** @ignore 关闭父组件的回调 */
    close: PropTypes.func,
    /** 是否被选中 */
    selected: PropTypes.bool,
    /** 是否禁用 */
    disabled: PropTypes.bool,
    /** 是否自动缩进 */
    autoIndent: PropTypes.bool,
    /** 缩进距离（单位px） */
    indent: PropTypes.number,
    /** 当前嵌套层数 */
    level: PropTypes.number,
    /** 前缀 */
    suffix: PropTypes.element,
    /** 后缀 */
    prefix: PropTypes.element,
    /** 同原生role */
    role: PropTypes.string,
    /** 提示文本 */
    tag: PropTypes.string,
    /** 是否可选中 */
    selectable: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    /** 是否紧凑显示 */
    compact: PropTypes.bool,
    /** 是否显示提示框 */
    disableTooltip: PropTypes.bool,
    /** 是否留出缩进空白 */
    inset: PropTypes.bool,
    prefixWidth: PropTypes.number,
  };

  static defaultProps = {
    prefixCls: 'ne-menu-item',
    disabled: false,
    currentValue: [],
    level: 1,
    inset: false,
    role: 'menuitem',
    compact: false,
    tag: 'li',
    indentBase: 8,
    prefixWidth: 26,
    disableTooltip: false,
  };

  static displayName = 'NeatUI.MenuItem';

  keyDown = false;

  onKeyDown = event => {
    const { onKeyDown } = this.props;
    const { key } = event;
    if (!this.keyDown && key === ' ') {
      this.keyDown = true;
      event.persist();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
    if (event.target === this.el && (key === ' ' || key === 'Enter')) {
      event.preventDefault();
      this.onClick(event);
    }
  };

  onKeyUp = event => {
    const { onKeyUp } = this.props;
    if (event === ' ') {
      this.keyDown = false;
      event.persist();
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  onClick = e => {
    const { disabled, value, onSelect, onClick, close } = this.props;
    onClick && onClick(e);
    if (!disabled && value !== undefined) {
      onSelect && onSelect(e, value);
    }
    close && close();
  };

  render() {
    const {
      className,
      index,
      value,
      selected,
      disabled,
      prefixCls,
      onSelect,
      close,
      children,
      prefix,
      suffix,
      tabIndex,
      isLastNode,
      level,
      compact,
      indentBase,
      searchText,
      disableTooltip,
      tag: Title,
      indent,
      autoIndent,
      selectable,
      currentValue,
      inset,
      mode,
      autoFold,
      prefixWidth,
      multiple,
      ...other
    } = this.props;
    let itemSelected = false;
    if (selected != null) {
      itemSelected = selected;
    } else {
      itemSelected =
        selectable &&
        value != null &&
        (Array.isArray(currentValue) ? currentValue.includes(value) : currentValue === value);
    }
    const indentLevel = autoIndent ? level : 1;

    const isSelected = !disabled && selectable && itemSelected;
    const classes = classNames(
      prefixCls,
      {
        [`${prefixCls}-selected`]: isSelected,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-multiple`]: multiple,
      },
      className,
    );
    const prefixWithClass = isValidElement(prefix)
      ? cloneElement(prefix, {
          className: classNames(
            `${prefixCls}-prefix`,
            { [`${prefixCls}-prefix-compact`]: compact },
            prefix.props.className,
          ),
        })
      : prefix;
    const suffixIcon = isSelected && multiple ? <Check /> : suffix;
    const suffixWithClass = isValidElement(suffixIcon)
      ? cloneElement(suffixIcon, {
          className: classNames(`${prefixCls}-suffix`, suffixIcon.props.className),
        })
      : null;
    const content = compact ? (
      prefixWithClass || (
        <div className={`${prefixCls}-prefix ${prefixCls}-prefix-compact`}>
          {children &&
            (children[0] && children[0].toUpperCase ? children[0].toUpperCase() : children)}
        </div>
      )
    ) : (
      <Fragment>
        {prefixWithClass}
        <div className={`${prefixCls}-content`}>{children}</div>
        {suffixWithClass}
      </Fragment>
    );
    const title = (
      <Title
        {...other}
        style={{
          paddingLeft:
            indentLevel * indent +
            (compact ? 0 : indentBase) +
            (!prefix && inset ? prefixWidth : 0),
        }}
        tabIndex={disabled || !itemSelected ? -1 : 0}
        className={classes}
        onKeyDown={this.onKeyDown}
        onKeyUp={this.onKeyUp}
        onClick={this.onClick}>
        {content}
      </Title>
    );
    return compact && !disableTooltip ? (
      <Tooltip content={title} autoAdjustPosition position="right">
        {children}
      </Tooltip>
    ) : (
      title
    );
  }
}
const connectedMenuItem = connect(MenuItem);
connectedMenuItem.isMenuItem = true;

export default connectedMenuItem;



// WEBPACK FOOTER //
// ./src/menu/MenuItem.jsx